import { ProjectBulkMergePayload, ProjectSourceType } from 'api/project';
import { API_DATE_FORMAT } from 'components/atoms/due-date-picker';
import { ImportFromTemplateFormValues } from './types';

export const toProjectBulkMergePayload = (
  values: ImportFromTemplateFormValues,
): ProjectBulkMergePayload[] => {
  return (values.sources ?? []).map(({ startDate, source, ...rest }) => ({
    ...rest,
    source: { sourceId: source.value, sourceType: ProjectSourceType.Template },
    startDate: startDate.format(API_DATE_FORMAT),
  }));
};
